// extracted by mini-css-extract-plugin
export default {"outer":"MobileVerification_outer__U0Tqd","otpButton":"MobileVerification_otpButton__6safk"};